import React, { Component } from 'react';
import { ObjectType } from '../types/object.type';
import Image from './image.component';
import Text from './text.component';
import '../styles/object.css';
import TranslationService from '../services/translation.service';
import { AppContext } from '../context';

class Object extends Component<{object: ObjectType}> {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;

  render ()  {
    const { state } = this.context;
    const { title, images, hidden, price, bedrooms, bathrooms, field_object_canton_postcode, field_object_canton_canton, surface, url } = this.props.object;
    if (hidden) {
      return <></>;
    }

    const firstImage = (images !== undefined ? images[0] : false);
    return <div
      className={'object' + (state.highlight && this.props.object.nid === state.highlight ? ' highlight' : '') }>
      <div className='images'>
        {firstImage ?
          <Image
            src={firstImage}
            alt=''
            width={440}
            height={250}></Image>
          :<></>}
      </div>
      <div className='main'>
        <div className='price' dangerouslySetInnerHTML={{ __html: (price ? price : '') }}/>
        <div className='title'>{title}</div>
      </div>
      <div className='informations'>
        <div className='bedrooms'>
          <span className='icon'>
            <img src='https://www.luxury-places.ch/themes/custom/luxuryplaces/img/icons/beds.svg'
              loading='lazy'
              width={30}
              height={30}
              alt={TranslationService.getMessage('Bedrooms', this.context.state.language)} />
          </span>
          <span className='value'>{bedrooms ? bedrooms : 'N/A'}</span>
          <span className='text'><Text text={'Bedrooms'}/></span>
        </div>
        <div className='bathrooms'>
          <span className='icon'>
          <img src='https://www.luxury-places.ch/themes/custom/luxuryplaces/img/icons/baths.svg'
            loading='lazy'
            width={30}
            height={30}
            alt={TranslationService.getMessage('Bathrooms', this.context.state.language)} />
          </span>
          <span className='value'>{bathrooms ? bathrooms : 'N/A'}</span>
          <span className='text'><Text text={'Bathrooms'}/></span>
        </div>
        <div className='surface'>
          <span className='icon'>
            <img src='https://www.luxury-places.ch/themes/custom/luxuryplaces/img/icons/house.svg'
              loading='lazy'
              width={30}
              height={30}
              alt={TranslationService.getMessage('SQM', this.context.state.language)} />
          </span>
          <span className='text'>
            <span className='value'>{surface ? surface : 'N/A'}</span>
            &nbsp;
            <Text text={'SQM'}/>
          </span>
        </div>
        <div className='postcode'>
          <span className='icon'>
            <img src='https://www.luxury-places.ch/themes/custom/luxuryplaces/img/icons/rooms.svg'
              loading='lazy'
              width={30}
              height={30}
              alt={TranslationService.getMessage('Postcode', this.context.state.language)} />
          </span>
          <span className='text'>
            <span className='value'>{field_object_canton_postcode ? field_object_canton_postcode : 'N/A'}</span>
            &nbsp;
            {field_object_canton_canton ? field_object_canton_canton : ''}
          </span>
        </div>
        <div className='details'>
          <a href={url} target='_blank' rel="noreferrer">
            <Text text={'Details'}/>
          </a>
        </div>
      </div>
    </div>
  };
}
export default Object;
